'use client';

import { OptimizelyDecideOption } from '@optimizely/optimizely-sdk';
import { useEffect } from 'react';

import { useOptimizely } from '@libs/common-next';

const TRACK_AB_TEST_EVENT = 'trackABTestContentSquare';

export function useSyncExperiments() {
    const { instance, context } = useOptimizely();

    useEffect(() => {
        if (!instance || !context || typeof window === 'undefined') return;

        Object.entries(context.decideAll([OptimizelyDecideOption.DISABLE_DECISION_EVENT]))
            .filter(([flagKey, decision]) => {
                const ruleKey = decision.ruleKey;
                if (!ruleKey || !decision.variationKey) return false;

                const experimentRules = instance.getOptimizelyConfig()?.featuresMap[flagKey]?.experimentRules ?? [];
                return experimentRules.some(experiment => experiment.key === ruleKey);
            })
            .forEach(([flagKey, decision]) => {
                window.dataLayer = window.dataLayer ?? [];
                window.dataLayer.push({
                    event: TRACK_AB_TEST_EVENT,
                    optimizely_flag_key: `AB_OP_SS_${flagKey}`,
                    optimizely_flag_value: decision.variationKey,
                });
                if (decision.variables?.ga_tracking === true) {
                    window.dataLayer.push({
                        event: 'optimizely_decision_server',
                        optimizely_flag_key: flagKey,
                        optimizely_flag_value: decision.variationKey,
                    });
                }
            });
    }, [instance, context]);

    return null;
}
